import { Input } from '@smartgift/frontend-toolkit';
import styled from 'styled-components';

import { DEVICE } from '@hero/constants';

const ProductFilters = styled.div`
  display: flex;
  flex: 1;
  flex-direction: row;
  flex-wrap: wrap;
  gap: 12px;
`;

const SelectedCount = styled.div`
  align-items: center;
  background: var(--color-bg-default);
  border: 1px solid var(--color-accent-primary-default);
  border-radius: 50%;
  color: var(--color-components-input-fg-strong, #0d1e46);
  display: flex;
  font-size: 14px;
  font-weight: 700;
  height: 22px;
  justify-content: center;
  position: absolute;
  right: -10px;
  top: -10px;
  width: 22px;
`;

const CustomSelectWrapper = styled.div`
  display: inline-block;
  position: relative;

  .placeholder {
    color: var(--color-neutral-800);
    font-size: 12px;
    font-style: normal;
    font-weight: bold;
    left: 15px;
    pointer-events: none;
    position: absolute;
    text-transform: none;
    top: 50%;
    transform: translateY(-50%);
    z-index: 1;
    &.focused {
      opacity: 0;
    }
  }
`;

const Wrapper = styled.div`
  ${DEVICE.mobile.max} {
    width: 100%;

    ${CustomSelectWrapper} {
      width: 100%;
    }
  }
  .table-filter-bar-wrapper {
    display: flex;
  }

  .filter-item-wrapper {
    display: flex;
    font: inherit;
    border: none;
    align-items: center;
    margin-left: 24px;
    padding: 4px 10px;
    background: var(--color-accent-secondary-weaker);
    cursor: pointer;
    border-radius: 26px;

    svg {
      width: 20px;

      path {
        fill: var(--color-accent-secondary-default);
        stroke: var(--color-accent-secondary-default);
      }
    }

    .filter-item-name {
      color: var(--color-neutral-800);
      font-size: 12px;
      font-weight: 600;
      line-height: 24px;
    }

    &:hover {
      background: var(--color-gray-25);
    }
  }

  .filter-item-name {
    margin-left: 12px;
  }
`;

const MenuTitle = styled.p`
  color: var(--color-accent-secondary-default);
  font-size: 12px;
  font-weight: 700;
  margin-bottom: 8px;
  margin-top: 16px;
`;

const MenuListWrapper = styled.div``;

const SearchInput = styled(Input)`
  border-bottom: 1px solid var(--color-accent-secondary-weaker);
  padding: 12px;
`;

export {
  CustomSelectWrapper,
  MenuListWrapper,
  MenuTitle,
  ProductFilters,
  SearchInput,
  SelectedCount,
  Wrapper
};
